import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { AreaMultiselectComponent } from './area-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        AreaMultiselectComponent
    ],
    exports: [
        AreaMultiselectComponent
    ]
})
export class AreaMultiselectModule { }
